import { Avatar } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import { deepOrange } from "@mui/material/colors";

export const AvatarApp = ({
    img = null,
    textToGenerateAvatar = "",
    size = 35, // Tamaño por defecto
    roundedCircle = true,
}) => {
    const getVariant = () => {
        if (typeof roundedCircle === "string") {
            return ["circular", "square", "rounded"].includes(roundedCircle)
                ? roundedCircle
                : "circular";
        }
        return roundedCircle ? "circular" : "square";
    };

    const styleAvatar = {
        marginRight: 1,
        marginLeft: 1,
        height: size, // Usar size para alto
        width: size, // Usar size para ancho
        display: "inline-flex",
        verticalAlign: "middle",
    };

    const stringToColor = (string) => {
        let hash = 0;
        for (let i = 0; i < string.length; i += 1) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }

        // Generar matiz (hue) basado en el hash (0-360 grados)
        const hue = Math.abs(hash) % 360;
        // Saturación baja (30-50%) para colores suaves
        const saturation = 40 + (Math.abs(hash) % 20);
        // Luminosidad media (50-70%) para colores equilibrados
        const lightness = 40 + (Math.abs(hash) % 20);

        // Convertir HSL a hexadecimal
        const hslToHex = (h, s, l) => {
            l /= 100;
            const a = (s * Math.min(l, 1 - l)) / 100;
            const f = (n) => {
                const k = (n + h / 30) % 12;
                const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
                return Math.round(255 * color)
                    .toString(16)
                    .padStart(2, "0");
            };
            return `#${f(0)}${f(8)}${f(4)}`;
        };

        return hslToHex(hue, saturation, lightness);
    };


    const stringAvatar = (name) => {
        if (!name || typeof name !== "string") {
            return {
                sx: {
                    bgcolor: deepOrange[500],
                    ...styleAvatar,
                },
                alt: "Unknown",
                children: "??",
                variant: getVariant(),
            };
        }

        let initials = "";
        const trimmedName = name.trim();

        if (trimmedName.includes("@")) {
            const [username] = trimmedName.split("@");
            initials =
                username.length > 1
                    ? `${username[0]}${username[1]}`
                    : username[0] || "?";
        } else {
            const nameParts = trimmedName.split(" ");
            initials =
                nameParts.length > 1
                    ? `${nameParts[0][0] || ""}${nameParts[1][0] || ""}`
                    : `${nameParts[0][0] || ""}`;
        }

        return {
            sx: {
                bgcolor: stringToColor(trimmedName),
                ...styleAvatar,
            },
            alt: trimmedName || "Avatar",
            children: initials.toUpperCase() || "??",
            variant: getVariant(),
        };
    };

    return (
        <Avatar
            {...(img
                ? {
                      src: img,
                      alt: textToGenerateAvatar || "Avatar",
                      sx: styleAvatar,
                      variant: getVariant(),
                  }
                : stringAvatar(textToGenerateAvatar))}
        />
    );
};

AvatarApp.propTypes = {
    img: PropTypes.string,
    textToGenerateAvatar: PropTypes.string,
    size: PropTypes.number,
    roundedCircle: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.oneOf(["circular", "square", "rounded"]),
    ]),
};
